import { useQuery, useMutation } from "@apollo/client";
import {
  QUEUE_OVERVIEW,
  QUEUE_JOBS,
  QUEUE_DLQ_JOBS,
  RETRY_QUEUE_JOB,
  REMOVE_QUEUE_JOB,
  RETRY_ALL_FAILED_JOBS,
  CLEAN_QUEUE_JOBS,
  PROMOTE_QUEUE_JOB,
} from "../graphql";
import type {
  QueueOverview,
  QueueJobsResult,
  QueueJobsInput,
} from "../types";

// ─── Queries ─────────────────────────────────────────────────────────────────

export function useQueueOverview(pollInterval = 10_000) {
  return useQuery<{ queueOverview: QueueOverview }>(QUEUE_OVERVIEW, {
    fetchPolicy: "cache-and-network",
    pollInterval,
  });
}

export function useQueueJobs(input: QueueJobsInput, skip = false) {
  return useQuery<{ queueJobs: QueueJobsResult }>(QUEUE_JOBS, {
    variables: { input },
    skip,
    fetchPolicy: "cache-and-network",
  });
}

export function useQueueDlqJobs(
  queueName: string,
  limit = 20,
  offset = 0,
  skip = false,
) {
  return useQuery<{ queueDlqJobs: QueueJobsResult }>(QUEUE_DLQ_JOBS, {
    variables: { queueName, limit, offset },
    skip,
    fetchPolicy: "cache-and-network",
  });
}

// ─── Mutations ───────────────────────────────────────────────────────────────

export function useRetryQueueJob() {
  return useMutation<{ retryQueueJob: boolean }>(RETRY_QUEUE_JOB, {
    refetchQueries: ["QueueOverview", "QueueJobs", "QueueDlqJobs"],
  });
}

export function useRemoveQueueJob() {
  return useMutation<{ removeQueueJob: boolean }>(REMOVE_QUEUE_JOB, {
    refetchQueries: ["QueueOverview", "QueueJobs", "QueueDlqJobs"],
  });
}

export function useRetryAllFailedJobs() {
  return useMutation<{ retryAllFailedJobs: number }>(RETRY_ALL_FAILED_JOBS, {
    refetchQueries: ["QueueOverview", "QueueJobs", "QueueDlqJobs"],
  });
}

export function useCleanQueueJobs() {
  return useMutation<{ cleanQueueJobs: number }>(CLEAN_QUEUE_JOBS, {
    refetchQueries: ["QueueOverview", "QueueJobs"],
  });
}

export function usePromoteQueueJob() {
  return useMutation<{ promoteQueueJob: boolean }>(PROMOTE_QUEUE_JOB, {
    refetchQueries: ["QueueOverview", "QueueJobs"],
  });
}
